import { Card, makeStyles } from "@material-ui/core";
import React from "react";
import { Popper } from "../Popper/Popper";
import { CalendarLegend } from "./CalendarLegend";

const useStyles = makeStyles(theme => ({
    popper: {
        // Hack to prevent calendar squares/circles from showing on top of popup
        zIndex: 1000
    },
    content: {
        padding: theme.spacing(2)
    }
}));

export interface CalendarLegendPopupProps extends React.HTMLAttributes<HTMLDivElement> {
    trigger: React.ReactElement<any, any>;
}

// Defaults to the Calendar widget's own legend when no children are given, so other widgets
// (e.g. ZapThruIT's ScheduleWidget) can reuse the same trigger/popup/card chrome with their own
// CalendarLegendSection/CalendarLegendItem content instead.
export function CalendarLegendPopup(props: React.PropsWithChildren<CalendarLegendPopupProps>) {
    const classes = useStyles();

    return (
        <Popper
            trigger={props.trigger}
            placement="bottom-end"
            modifiers={{
                offset: {
                    offset: "0, 10"
                }
            }}>
            <Card variant="outlined" className={classes.content}>
                {props.children ?? <CalendarLegend />}
            </Card>
        </Popper >
    );
}